import { render } from "./NodeRedManagement.vue?vue&type=template&id=ccb871bc&ts=true"
import script from "./NodeRedManagement.vue?vue&type=script&lang=ts"
export * from "./NodeRedManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__